{% block sw_multi_select %}
    <div>

        <div class="klarna-payment-settings-kp__info">
            <ul>
                <li>
                    <h3>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.payLater.title') }}</h3>
                    <img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.png" :title="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.payLater.title')" :alt="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.payLater.title')"/>
                    <p>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.payLater.description') }}</p>
                </li>
                <li>
                    <h3>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.sliceIt.title') }}</h3>
                    <img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.png" :title="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.sliceIt.title')" :alt="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.sliceIt.title')"/>
                    <p>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.sliceIt.description') }}</p>
                </li>
                <li>
                    <h3>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.payNow.title') }}</h3>
                    <img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.png" :title="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.payNow.title')" :alt="$tc('klarna-payment-configuration.settingsForm.klarnaPayments.payNow.title')"/>
                    <p>{{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.payNow.description') }}</p>
                    <p><mt-icon name="regular-info-circle" small color="#3498db"/> {{ $tc('klarna-payment-configuration.settingsForm.klarnaPayments.payNow.additional') }}</p>
                </li>
            </ul>
        </div>

        {% parent() %}

    </div>
{% endblock %}
